import React, { useEffect } from "react";
import { DashboardViewModel } from "../../viewmodels/dashboard/DashboardViewModel";
import ProductInventoryStatsCard from "./cards/ProductInventoryStatsCard";
import StatsComponents from "../../components/stats/StatsComponents";
import TopSellingItemsCard from "./cards/TopSellingItemsCard";
import TopSellingSalesPersons from "./cards/TopSellingSalesPersons";
import LineChart from "../../components/charts/LineChart";

interface DashboardProps {
  logout: () => void;
}

const Dashboard: React.FC<DashboardProps> = ({ logout }) => {
  const {
    getStatsSummaries,
    getProductInventoryStats,
    getTopSellingItemsStats,
    fetchTopFiveSalesPersons,
    statsSummaries,
    productInventoryStats,
    topSellingItemsStats,
    topSalesPersonsStats,
  } = DashboardViewModel(logout);

  useEffect(() => {
    getStatsSummaries();
    getProductInventoryStats();
    getTopSellingItemsStats();
    fetchTopFiveSalesPersons();
  }, []);

  const analytics = {
    title: "Welcome back Jason",
    loading: false,
  };

  return (
    <div>
      <div className="mt-2 pb-4 px-4 sm:px-6 lg:px-8">
        <div>
          <StatsComponents
            title="Welcome back, Jason"
            statsSummaries={statsSummaries}
            loading={false}
          />
        </div>
        <div className="mt-8">
          <ul className="grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8">
            <ProductInventoryStatsCard
              productInventoryStats={productInventoryStats}
              loading={false}
            />

            <TopSellingItemsCard
              topSellingItemsStats={topSellingItemsStats}
              loading={false}
            />
            <TopSellingSalesPersons
              topSalesPersonsStats={topSalesPersonsStats}
              loading={false}
            />

            <div className="col-span-2">
              <LineChart />
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
